import React, {forwardRef, useImperativeHandle, useRef, useState} from 'react';
import {Button, Modal, Tab, Tabs} from "react-bootstrap";
import Loading from "../../components/loading";
import {Form, Formik} from "formik";
import {buildingRequestSchema} from "../../utils/schemas";
import FormGroup from "../../components/form-group";
import HelperService from "../../services/helper-service";
import Section from "../../components/section";
import {useGlobalNotificationMessage} from "../../context/message";
import {useBuildingService} from "../../services/building-service";
import {
  AppRoutes,
  BuildingAccountingPeriodTypes,
  BuildingAttachmentTypes,
  BuildingOwnershipTypes
} from "../../utils/constants";
import Fileupload from "../../components/files/fileupload";
import Attachment from "../../components/files/attachment";
import AddEditAttachmentModal from "../attachment/add-edit-attachment-modal";
import AddEditManagerModal from "./add-edit-manager-modal";
import Select from "react-select";
import {useManagerService} from "../../services/manager-service";
import AddEditBuildingStatModal from "./add-edit-building-stat-modal";
import {useBuildingStatService} from "../../services/building-stat-service";
import AddEditArticleModal from "../articles/add-edit-article-modal";
import ArticleCell from "../../components/articles/article-cell";
import {useArticleService} from "../../services/article-service";
import {useAddressService} from "../../services/address-service";
import {Link} from "react-router-dom";
import {useBuildingStatTypeService} from "../../services/building-stat-type-service";
import {useAttachmentCategoryService} from "../../services/attachment-category-service";

const AddEditBuildingModal = forwardRef( ({onSuccess=null, ...props}, ref) => {
  const [show, setShow] = useState(false);
  const [model, setModel] = useState();
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [filesData, setFilesData] = useState([]);
  const [managersList, setManagersList] = useState([]);
  const [buildingStatDataLoading, setBuildingStatDataLoading] = useState(true);
  const [buildingStatTypesList, setBuildingStatTypesList] = useState([]);
  const [attachmentCategoriesList, setAttachmentCategoriesList] = useState([]);
  const [selectedManagers, setSelectedManagers] = useState([]);
  const [lastStats, setLastStats] = useState(null);
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();
  const [reset, setReset] = useState(0);

  const addEditAttachmentModal = useRef();
  const addEditManagerModal = useRef();
  const addEditBuildingStatModal = useRef();
  const addEditArticleModal = useRef();

  let formSchema = buildingRequestSchema;

  let buildingService = useBuildingService();
  let buildingStatService = useBuildingStatService();
  let buildingStatTypeService = useBuildingStatTypeService();
  let managerService = useManagerService();
  let articleService = useArticleService();
  let addressService = useAddressService();
  let attachmentCategoryService = useAttachmentCategoryService();

  //expose api for interacting with component
  useImperativeHandle(ref, () => ({
    openModal: openModal,
    closeModal: closeModal,
  }));

  const openModal = (model=null) => {
    setLoading(true);
    setFiles([]);

    let promises = [
      Promise.resolve('initOk')
    ];

    promises.push(managerService.getList());

    if (model && model.id){
      promises.push(getDetail(model.id));
      promises.push(attachmentCategoryService.getList());
    }

    Promise.all(promises).then(([initOk, _managersList=[], detail= {}, _attachmentCategoriesList=[]])=>{
      setManagersList(_managersList);
      setAttachmentCategoriesList(_attachmentCategoriesList);
      setSelectedManagers(detail.managers);

      let newDetail = Object.assign({}, detail);
      setModel(formSchema.cast(newDetail));
      setLoading(false);
    });

    setShow(true);
  }
  const closeModal = () => {
    setShow(false);
    setReset(reset+1);
    setModel(formSchema.cast());
  }

  const reloadBuildingStats = () => {
    setBuildingStatDataLoading(true);
    setBuildingStatTypesList([]);
    setLastStats([]);

    let promises = [];
    if (model && model.id){
      promises.push(buildingStatService.getLastStats(model.id));
      promises.push(buildingStatTypeService.getList());

      Promise.all(promises).then(([_lastStats = [], buildingStatTypes = []])=>{
        setLastStats(_lastStats);
        setBuildingStatTypesList(buildingStatTypes);
        setBuildingStatDataLoading(false);
      });
    } else {
      setBuildingStatDataLoading(false);
    }
  }

  const getDetail = (id) => {
    return buildingService.getDetail(id);
  }

  const onAddEditAttachmentCallback = (item)=>{
    setModel((model)=>{
      let m = model;
      m.attachments = [...HelperService.addOrReplaceItemInList(m.attachments, item)];
      return Object.assign({}, m);
    })
  };

  const onAttachmentDelete = (item)=>{
    setModel((model)=>{
      let m = model;
      m.attachments = [...HelperService.removeItemFromList(m.attachments, item)];
      return Object.assign({}, m);
    })
  };

  const onAddEditBuildingStatCallback = (item)=>{
    setModel((model)=>{
      let m = model;
      m.buildingStats = [...HelperService.addOrReplaceItemInList(m.buildingStats, item)];
      return Object.assign({}, m);
    })

    buildingStatService.getLastStats(model.id)
      .then((res) => {
        setLastStats(res);
      })
      .catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa uložiť zmeny.");
      })
  };

  const onAddEditManagerCallback = (item)=>{
    setManagersList([...HelperService.addOrReplaceItemInList(managersList, item)])
  };

  const selectManager = (items=null)=>{
    setSelectedManagers([...items]);
  };

  const onAddEditArticleCallback = (item)=>{
    setModel((model)=>{
      let m = model;
      m.all_articles = [...HelperService.addOrReplaceItemInList(m.all_articles, item)];
      return Object.assign({}, m);
    })
  };

  const delAddress = (item) => {
    if (true===confirm('Odstrániť adresu?')){
      addressService.delModel(item.id)
        .then(()=>{
          let newModel = {...model};
          newModel.addresses = [...HelperService.removeItemFromList(newModel.addresses, item)];
          setModel(newModel);
        })
        .catch(error => {
          HelperService.handleApiErrors(error, addErrorMessage);
        })
    }
  };

  const delArticle = (item)=>{
    if (true===confirm('Odstrániť článok?')){
      articleService.delModel(item.id)
        .then(()=>{
          setModel((model)=>{
            let m = model;
            m.all_articles = [...HelperService.removeItemFromList(m.all_articles, item)];
            return Object.assign({}, m);
          })
        })
        .catch(error => {
          HelperService.handleApiErrors(error, addErrorMessage);
        })
    }
  };

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    removeMessage();
    let reqValues = {...values};
    if (files && files.length){
      reqValues.files = files;
    }

    reqValues.sync_managers = selectedManagers?.length>0 ? selectedManagers.map((i)=>i.id) : [];

    delete reqValues.managers;
    delete reqValues.attachments;
    delete reqValues.addresses;

    buildingService.addEditModel(reqValues, reqValues.id)
      .then((res) => {
        if (onSuccess && 'function' === typeof onSuccess){
          onSuccess(res);
        }
        setFiles([]);
        closeModal();
      })
      .catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa uložiť zmeny.");
        HelperService.handleFormErrors(error, setErrors);
      })
      .finally(()=>{ setSubmitting(false);});
  };

  return (
    <>
      <Formik
        key={reset}
        enableReinitialize={true}
        initialValues={formSchema.cast(model) || formSchema.cast()}
        validationSchema={formSchema}
        onSubmit={onSubmit}
      >
        {({ isSubmitting, errors, touched, handleSubmit, setFieldValue}) => (

          <Modal size='lg' show={!!show} onHide={closeModal} centered>
            <Modal.Header closeButton>
              { model && <Modal.Title>{ !model.id ? 'Nová budova' : 'Úprava budovy' }</Modal.Title>}
            </Modal.Header>
            <Modal.Body>
              <Section animation={HelperService.getRandomAnimation()}>

                {loading && <Loading className="m-2" />}

                {!loading && <Form>

                  <AddEditAttachmentModal ref={addEditAttachmentModal} onSuccess={(item)=>onAddEditAttachmentCallback(item)} />
                  <AddEditManagerModal ref={addEditManagerModal} onSuccess={onAddEditManagerCallback} />
                  <AddEditBuildingStatModal ref={addEditBuildingStatModal} onSuccess={onAddEditBuildingStatCallback} />
                  <AddEditArticleModal ref={addEditArticleModal} onSuccess={onAddEditArticleCallback} />

                  <Tabs
                    defaultActiveKey="info"
                    className="mb-3"
                    onSelect={(key)=> key==='asset-values' ? reloadBuildingStats() : null}
                  >
                    <Tab eventKey="info" title="Info">
                      <div className="row">
                        <FormGroup
                          name="title"
                          placeholder="Názov"
                          label="Názov"
                          className="col-md-4"
                          touched={touched} errors={errors} schema={formSchema}
                        />

                        <FormGroup
                          name="ownership_type"
                          type="select"
                          options={Object.values(BuildingOwnershipTypes)}
                          optionLabel="title"
                          optionKey="val"
                          placeholder="typ"
                          label="Typ vlastníctva"
                          className="col-md-4"
                          touched={touched} errors={errors} schema={formSchema}
                        />

                        <FormGroup
                          name="accounting_period_type"
                          type="select"
                          options={Object.values(BuildingAccountingPeriodTypes)}
                          optionLabel="title"
                          optionKey="val"
                          placeholder="typ"
                          label="Obdobie zadávania štatistík"
                          className="col-md-4"
                          touched={touched} errors={errors} schema={formSchema}
                        />

                        <FormGroup
                          type="textarea"
                          name="description"
                          placeholder="Poznámka"
                          rows="8"
                          label="Poznámka"
                          className="col-md-12"
                          touched={touched} errors={errors} schema={formSchema}
                        />
                      </div>
                    </Tab>
                    <Tab eventKey="asset-values" title="Údaje" disabled={!model?.id}>
                      <div className="row">
                        <p className='text-muted'>
                          <Link to={AppRoutes.buildingStats.path} className="btn btn-outline-secondary btn-sm">
                                <span className="mdi mdi-book-edit"></span> Spravovať údaje</Link>
                        </p>

                        {buildingStatDataLoading && <Loading />}

                        {!buildingStatDataLoading && buildingStatTypesList.map((statType)=>
                          <div className="col-sm-6" key={`stat-type-${statType.id}`}>
                            <h5 className="mb-0">{statType.title}</h5>
                            <h6 className="text-muted">{statType.path}</h6>
                            <p className='text-muted'>
                              {statType.description}
                              <span className="btn btn-outline-secondary btn-sm"
                                    onClick={()=>addEditBuildingStatModal.current.openModal(null, model.id, statType.id)}><span className="mdi mdi-plus-box"></span> pridať</span>
                            </p>
                            {lastStats && lastStats[statType.id] && <div className="building-stat shadow-sm d-flex position-relative p-2 bg-white mb-1">
                              <div className="d-flex flex-column justify-content-center align-items-start p-1 text-break">
                                <div className="mb-0">Počet záznamov: <strong>{lastStats[statType.id].count}</strong></div>
                                {lastStats[statType.id].val && <div>
                                  <div className="mb-0">Posledná hodnota: <strong>{lastStats[statType.id].val.stat}</strong></div>
                                  <div className="mb-0">Ku dňu: <strong>{HelperService.formatDate(lastStats[statType.id].val.date_at)}</strong></div>
                                </div>}
                              </div>
                            </div>
                            }
                          </div>
                        )}
                      </div>
                    </Tab>
                    <Tab eventKey="managers" title="Správcovia" disabled={!model?.id}>
                      <p className='text-muted'>Priradte správcov do budovy. Ak nenájdete správcu, môžete
                        &nbsp;<span className="clickable link-primary text-decoration-underline"
                              onClick={()=>addEditManagerModal.current.openModal()}>vytvoriť nového</span>.
                      </p>
                      <Select
                        options={managersList?.map(
                          (item)=>{
                            item.value = item.id;
                            item.label = item.name;
                            return item;
                          }
                        )}
                        placeholder={'Vyberte správcov'}
                        isSearchable
                        isClearable
                        isMulti
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            'borderRadius': '16px',
                          }),
                        }}
                        value={selectedManagers?.map(
                          (item)=>{
                            item.value = item.id;
                            item.label = item.name;
                            return item;
                          }
                        )}
                        onChange={selectManager}
                      />

                    </Tab>
                    <Tab eventKey="attachments" title="Dokumenty">
                      <div className="row">
                        <div className="col-sm-12">
                          <h5>Dokumenty</h5>
                          <p className='text-muted'>Pridajte dokumenty na stiahnutie k budove</p>
                          <Fileupload
                            attachmentTypes={Object.values(BuildingAttachmentTypes)}
                            attachmentCategories={null}
                            cardClass="col-sm-12"
                            files={files}
                            filesData={filesData}
                            onChange={({files, filesData})=>{setFiles(files); setFilesData(filesData)}}
                            setFieldValue={setFieldValue} />
                          {model?.attachments && model?.attachments?.length>0 && <div className="row">
                            {model.attachments.map((att)=>{
                              return <div key={att.id} className="col-12">
                                <Attachment attachment={att}
                                            onDelSuccess={(att)=>onAttachmentDelete(att)}
                                            editAction={(att)=>addEditAttachmentModal.current.openModal(att, Object.values(BuildingAttachmentTypes), null)}
                                /></div>;
                            })}
                          </div>}
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="articles" title="Články">
                      <div className="row">
                        <div className="col-sm-12">
                          <h5>Články</h5>
                          <p className='text-muted'><span className="clickable link-primary text-decoration-underline" onClick={()=>addEditArticleModal.current.openModal(null, model.id)}>Pridajte</span> novinky a informácie k budove</p>
                          {model?.all_articles && model?.all_articles?.length>0 && <div className="row">
                            {model.all_articles.map((art)=>{
                              return <div key={art.id} className="col-12">
                                <ArticleCell
                                  article={art}
                                  del={(art)=>delArticle(art)}
                                  edit={(art)=>addEditArticleModal.current.openModal(art,model.id)} /></div>;
                            })}
                          </div>}
                        </div>
                      </div>
                    </Tab>
                  </Tabs>

                  <div className="clearfix"></div>

                </Form>}

              </Section>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="outline-secondary" onClick={closeModal}>Zatvoriť</Button>
              <Button type="submit" variant="primary" onClick={handleSubmit} disabled={isSubmitting}>Odoslať</Button>
            </Modal.Footer>
          </Modal>
        )}
      </Formik>

    </>
  );
});

export default AddEditBuildingModal;
